import css from './index.module.scss';

export default function InstallationPopup({ callInstallation }: any) {
    const lists = ['Order Placement', 'Schedule Installation', 'Finalize Appointment', 'Installation by Certificated Electricians'];
    return (
        <div className={`installation-popup ${css['installation-popup']}`}>
            <div className="installation-popup-content">
                <header className="installation-popup-header">
                    <svg
                        className="header-close"
                        onClick={() => callInstallation(false)}
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                    >
                        <path d="M6 5L19 18M19 5L6 18" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </header>
                <body className="installation-popup-body">
                    <p className="installation-title">{'Installation Consulting Service For EcoFlow Smart Home Panel 2'}</p>
                    <p className="installation-desc">
                        {
                            "With our service, you'll experience a seamless EcoFlow Smart Home Panel 2 installation. We connect you with a fully-trained local electrician and provide tracking from order to fitting."
                        }
                    </p>
                    <p className="installation-text">{"You'll get the following exclusive services:"}</p>
                    <ul className="lists">
                        {lists?.map((list: any, k: number) => (
                            <li className="list" key={k}>
                                <span className="list-step">{k + 1}</span>
                                <span className="list-text">{list}</span>
                            </li>
                        ))}
                    </ul>
                </body>
            </div>
        </div>
    );
}
